import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";

export const GTMCommonEvent = (eventName: string) => {
  dataLayer(eventName, {}, ["timestamp", "userType", "userId"]);
  return true;
};
